import {
  IAccountCreditExtendedData,
  isAccountCreditExtendedData,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import { TransactionHelpers } from '../../transaction-helpers';

export class AmendAccountCreditTransaction
  implements ITransactionAction<IAccountCreditExtendedData>
{
  icon = 'edit';
  label = 'Amend';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isAccountCreditExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IAccountCreditExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.canAmend$(data);
  }

  async do(
    data: ITransactionActionsData<IAccountCreditExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.amend(
      data.invoice,
      data.latestTransaction,
      'Amend Transaction'
    );
    this.inProgress$.next(false);
  }
}
